// @flow

import type { GARecorderFunction } from '@ta/platform.interactions';
import type { MediaAlbumServiceClient } from './types';

export const SERVLET_CLIENT_MAPPING: { [string]: MediaAlbumServiceClient } = {
  Hotels: 'h',
  MobileHotels: 'h',
  Hotel_Review: 'hr',
  Hotel_Feature: 'hf',
  MobileHotel_Review: 'hr',
  HotelHighlight: 'hh',
  MobileHotelHighlight: 'hh',
  'Hotel_Review-s1': 'hh',
  SmartDeals: 'sd',
  MobileSmartDeals: 'sd',
  HotelsList: 'hl',
  HotelsNear: 'hn',
  LastMinute: 'lm',
  ShowUserReviews: 'sur',
  ShowUserReviewsHotels: 'sur',
  ShowUserReviewsRestaurants: 'sur',
  ShowUserReviewsAttractions: 'sur',
  MobileShowUserReviews: 'sur',
  LocationPhotoDirectLink: 'lpdl',
  AccommodationCrossSells: 'acs',
  MobileNearbyHotels: 'nh',
  Restaurants: 'r',
  Vacation_Packages: 'vp',
  MobileVacation_Packages: 'vp',
  Attractions: 'a',
  Attraction_Review: 'ar',
  Unknown: 'un',
};

export const getMapsClientName = (): MediaAlbumServiceClient => 'maps';

const getClientNameForServlet = (
  servlet: ?string,
  trackEvent: GARecorderFunction,
): MediaAlbumServiceClient => {
  if (servlet && servlet.startsWith('HotelsList')) {
    // eslint-disable-next-line no-param-reassign
    servlet = 'HotelsList';
  }

  if (!servlet || !SERVLET_CLIENT_MAPPING[servlet]) {
    const context = !servlet ? 'falsyValue' : servlet;
    trackEvent({
      module: 'media-album-parts',
      action: 'invalidclient',
      context,
    });
    return 'un';
  }
  return SERVLET_CLIENT_MAPPING[servlet];
};

export default getClientNameForServlet;
